<template>
  <div class="album" ref="album" :class="{ 'album-bottom': !isNative && buttomBtnDisplay }">
    <transition name="slide-fade">
      <div class="purchase" v-show="privilegeTips">
        <div class="shadow" @click="privilegeTips = false"></div>
        <div class="app-content" v-show="!buyCheck">
          <template v-if="isDiscontinued">
            <h6>专辑已停售 不可购买</h6>
            <div class="app-btn-g">
              <a @click="privilegeTips = false" class="app-btn">知道了</a>
            </div>
          </template>
          <template v-else-if="album.charge == albumGoodsType.freeAlbumGoods && !userInfo">
            <h6>该内容需要登录或前往APP才可收听哦</h6>
            <div class="app-btn-g">
              <router-link to="/account/login-bySMS" class="app-btn">登录优学</router-link>
              <a :href="downloadApp" class="app-btn">前往APP收听</a>
            </div>
          </template>
          <template v-else-if="album.charge == albumGoodsType.chargeAlbumGoods">
            <h6>该内容为付费内容，请先购买</h6>
            <div class="app-btn-g" v-if="album.charge == albumGoodsType.chargeAlbumGoods">
              <a @click="buyAlbum" class="app-btn">立即购买</a>
            </div>
          </template>
          <template v-else-if="album.charge == albumGoodsType.packageAlbumGoods">
            <h6>该音频为VIP内容，需开通VIP课程包后才可收听哦</h6>
            <div class="app-btn-g">
              <a @click="privilegeTips = false" class="app-btn">再看看</a>
              <a @click="goToPkg" class="app-btn">开通VIP</a>
            </div>
          </template>
        </div>
      </div>
    </transition>
    <app-open :albumId="albumId" type="album" :mediaId="null" ref="appOpren"></app-open>
    <div class="banner-box" v-if="album">
      <div class="banner" :style="`background-image:url(${album.displayBigPhoto})`"></div>
      <div class="content">
        <h2>{{ album.name }}</h2>
        <h3>作者：{{ album.author || '佚名' }}</h3>
        <ul>
          <template v-for="(item, index) in album.tags">
            <li :key="index" v-if="index < 3">{{ item }}</li>
          </template>
        </ul>
      </div>
    </div>
    <div style="height:8px;background:#FAFAFC;"></div>
    <div class="tab-bar">
      <p v-for="(item, index) in tabBar" :key="index" @click="tabBarCurrentIndex = index">
        <span class="tab-item" :class="{ current: tabBarCurrentIndex === index }">{{ item }}</span>
      </p>
    </div>
    <div class="tab-wrapper">
      <div class="wrapper-content description" v-show="tabBarCurrentIndex == 0">
        <template v-if="album && album.displayDetailPhoto">
          <img class="album-detaim-img" :src="album && album.displayDetailPhoto" alt="">
        </template>
        <template v-else>
          <div class="content-item">
            <h5 class="depict-title">专辑简介</h5>
            <p>{{ (album && album.description) || '暂无' }}</p>
          </div>
          <div class="content-item">
            <h5 class="remark-title">编辑点评</h5>
            <p>{{ (album && album.remarks) || '暂无' }}</p>
          </div>
        </template>
      </div>
      <div class="wrapper-content detail" v-show="tabBarCurrentIndex == 1">
        <ul>
          <li
            v-for="(item, index) in mediaDetail.medias"
            :key="index"
            @click="toListen(item.trial, item.id)"
          >
            <h3>{{ index + 1 }}</h3>
            <div>
              <div class="media-title">
                <h4>{{ item.name }}</h4>
                <span v-if="!checkAlbumAuth && item.trial">试听</span>
              </div>
              <h5>{{ item.length | timeFilter }}</h5>
            </div>
            <button :class="{ unlock: checkAlbumAuth || item.trial }"></button>
          </li>
          <li class="isMore">
            <a :href="downloadApp" class="to-app">打开App，更多资源等待你~</a>
          </li>
        </ul>
      </div>
    </div>
    <album-botton-bar
      v-if="buttomBtnDisplay"
      :play="playButton"
      :share="shareButton"
      :buy="buyButton"
      :isDiscontinued="isDiscontinued"
      @bottomBarHandler="bottomBarHandler"
    ></album-botton-bar>
    <cus-share v-show="shareShow" @cancel="shareShow = false"></cus-share>
  </div>
</template>

<script>
import { resourceType, albumGoodsType } from '@/utils/const';
import { mapGetters } from 'vuex';
import { AppOpenAlert as AppOpen } from '@/components/common';
import { durationFormat } from '@/utils/filter';
import { CheckoutCion, AlbumBottonBar } from '@/components/goods';
import { wechatShareAlbum } from '@/mixins/wechatShare.js';
import { isEmpty } from 'lodash';
export default {
  mixins: [wechatShareAlbum],
  components: {
    AppOpen,
    CheckoutCion,
    AlbumBottonBar,
  },
  data() {
    return {
      resourceType,
      albumGoodsType,
      isShowAll: false,
      privilegeTips: false,
      shareShow: false,
      buyCheck: false,
      album: {},
      pageData: {
        pageSize: 10,
        pageNo: 1,
      },
      mediaDetail: {
        medias: [],
        mediaTotal: 0,
      },
      // 该专辑是否已购买
      isFree: false,
      // 该礼包是否已购买
      valid: false,
      // 该专辑是否可单独购买
      canBuy: false,
      goodsDetail: {
        // 1 表示可以单独购买 0不可以
        // canBuy: 0,
        // goodsName: "lwt_1s_seriesAlbum_1",
        // goodsNum: "20190430180231001895035",
        // marketPrice: 0,
        // // 普通付费商品VIP是否有折扣，80边表示有8折
        // memberDiscount: 80,
        // pic: "http://images.cms.zhibankeji.com/image/dev/1553672420974.png",
        // price: 1.43,
        // // 1表示会员礼包或者会员收费  2表示普通付费商品
        // privilege: 1,
        // type: 1,
        // // 专辑是否购买
        // buyStatus: 0,
        // // 折扣价
        // memberPrice: 0.8
      },
      packageDetail: {
        // 如果valid=1就说明该礼包已经购买，专辑都免费 valid=0未购买礼包
        // valid: 0
      },
      checkAlbumAuth: false,
      tabBar: ['课程介绍', '开始学习'],
      tabBarCurrentIndex: 0,
      earnMoney: 0,
      isDiscontinued: false,
    };
  },
  mounted() {
    this.initData();
  },
  watch: {
    shareInfo: {
      immediate: true,
      deep: true,
      handler: function(val) {
        this.shareParams(val);
      },
    },
  },
  methods: {
    async initData() {
      let { album } = await this.$api.api_v3_album_get({
        params: {
          id: this.$route.params.id,
        },
      });
      if (album) {
        this.album = album;
        document.title = album.name;
        this.loadMediaPage();
      }
      this.authAlbumCheck();
      if (this.album.charge == albumGoodsType.packageAlbumGoods) {
        this.belongsToPkgType();
      }
      if (this.album.charge != albumGoodsType.freeAlbumGoods) {
        this.getAlbumInfo();
      }
    },
    authAlbumCheck() {
      if (!this.uid) {
        this.checkAlbumAuth = false;
        return;
      }
      this.$api
        .resource_v1_auth_album_check_get({
          params: {
            albumId: this.$route.params.id,
            uid: this.uid,
          },
        })
        .then((e) => {
          if (e.result) {
            this.checkAlbumAuth = true;
          }
        });
    },
    loadMediaPage() {
      // 新接口
      this.$api
        .api_v3_media_search_page_with_pluses_post({
          path: { pluses: 'trial' },
          data: {
            albumId: this.album.id,
            status: 2,
            ...this.pageData,
          },
        })
        .then((e) => {
          this.mediaDetail = {
            medias: e.content,
            mediaTotal: e.total,
          };
          // this.loading = false;
        });
    },
    toListen(privilege, mediaId) {
      if (this.isDiscontinued&&!privilege) {
        this.privilegeTips = true;
        return;
      }
      if (!this.checkAlbumAuth && !privilege) {
        this.privilegeTips = true;
        this.buyCheck = false;
        return;
      }
      this.$router.push({
        name: 'player',
        params: {
          id: mediaId,
        },
        query: {
          albumId: this.album.id,
        },
      });
    },
    bottomBarHandler(nextParams) {
      switch (nextParams) {
        case 'toPlay':
          this.canPlay();
          break;
        case 'toShare':
          this.shareShow = true;
          break;
        case 'toBuy':
          this.buyAlbum();
          break;
        default:
          break;
      }
    },
    buyAlbum() {
      if (!this.userInfo) {
        // 登录
        this.$router.push('/account/login-bySMS');
        return;
      }
      this.$router.push(`/goods/checkoutAlbum/${this.albumId}${this.routerContextId ? '?contextId=' + this.routerContextId : ''}`);
    },
    // 试听
    canPlay() {
      let index = this.mediaDetail.medias.findIndex((item) => item.trial);
      if (index > -1) {
        this.$router.push({
          name: 'player',
          params: {
            id: this.mediaDetail.medias[index].id,
          },
          query: {
            albumId: this.album.id,
          },
        });
      } else {
        this.$createToast({
          txt: '暂无可试听课程',
          type: 'txt',
        }).show();
      }
    },
    // 判读专辑所属礼包
    belongsToPkgType() {
      this.$api
        .payment_v1_goods_album_member_package_get_get({
          params: {
            albumId: this.albumId,
          },
        })
        .then((e) => {
          if (e && e.length) {
            this.packageDetail = e[0];
            if (this.packageDetail.valid && this.packageDetail.valid == 1) {
              this.valid = true;
            }
          }
        });
    },
    // 查看专辑是否可以购买
    getAlbumInfo() {
      this.$api
        .payment_v1_goods_getGoodsNum_get({
          params: {
            id: this.albumId,
            type: this.resourceType.album,
          },
        })
        .then((e) => {
          if (!e) return;
          this.goodsDetail = e;
          if (this.goodsDetail.buyStatus && this.goodsDetail.buyStatus == 1) {
            // 该专辑已购买
            this.isFree = true;
          }
          if (this.goodsDetail.canBuy && this.goodsDetail.canBuy == 1) {
            // 该专辑可单独购买
            this.canBuy = true;
          }
          if (this.album.charge != albumGoodsType.freeAlbumGoods) {
            this.getAlbumDetail(this.goodsDetail.goodsNum);
          }
        });
    },
    // 获取专辑商品的goodsNum
    getAlbumDetail(goodsNum) {
      this.$api
        .payment_v1_goods_app_goodsNum_get({
          path: {
            goodsNum,
          },
        })
        .then(({ earnMoney, isDiscontinued }) => {
          this.earnMoney = earnMoney || 0;
          this.isDiscontinued = !!isDiscontinued;
        });
    },
    goToPkg() {
      this.$router.push(this.packageDetail.productType === 1 ? '/goods/parentPkg' : '/goods/pkg');
    },
  },
  computed: {
    ...mapGetters({
      isNative: 'externalInterface/isNative',
      isPlusMember: 'auth/isPlusMember',
      userInfo: 'auth/userInfo',
      uid: 'auth/uid',
      accessToken: 'auth/accessToken',
      selfInviteCode: 'auth/selfInviteCode',
      downloadApp: 'externalInterface/downloadApp',
    }),
    routerContextId() {
      return this.$route.query && this.$route.query.contextId ? this.$route.query.contextId : '';
    },
    albumId() {
      return this.$route.params.id;
    },
    vipText() {
      return this.isPlusMember
        ? {
            bannerText: '您是VIP，可享8折优惠特权哦~',
            buttonText: '立即续费',
          }
        : {
            bannerText: '开通VIP，即可享8折优惠特权哦~',
            buttonText: '开通VIP',
          };
    },
    buttomBtnDisplay() {
      if (this.album.charge == albumGoodsType.packageAlbumGoods) {
        //礼包内专辑
        // 普通用户且专辑可购买且已经单独购买
        return !((!this.isPlusMember && this.canBuy && this.isFree) || (this.valid && !this.canBuy));
      }
      if (this.album.charge == albumGoodsType.chargeAlbumGoods) {
        // 普通收费专辑
        return !(!this.isPlusMember && this.isFree);
      }
      // charge=0则免费
      return false;
    },
    playButton() {
      if (this.displayPlayerBtn) {
        return {
          text: '试听',
          icon: '/images/player.png',
        };
      }
    },
    displayPlayerBtn() {
      let flag = this.album.charge === albumGoodsType.packageAlbumGoods && !this.valid && !this.canBuy;
      return !this.isPlusMember || flag;
    },
    shareButton() {
      if (!this.displayPlayerBtn) {
        return { text: `分享赚 ￥ ${this.earnMoney}` };
      }
    },
    displayBuyBtn() {
      if (this.album.charge == albumGoodsType.packageAlbumGoods) {
        //礼包内专辑
        return !this.valid && this.canBuy && !this.isFree;
      }
      if (this.album.charge == albumGoodsType.chargeAlbumGoods) {
        // 普通专辑
        return !this.isFree;
      }
    },
    hasDiscount() {
      // VIP用户且有折扣
      return this.isPlusMember && this.goodsDetail.memberDiscount > 0 && this.goodsDetail.memberDiscount < 100;
    },
    discount() {
      return this.hasDiscount ? `${this.goodsDetail.memberPrice || 0}` : `${this.goodsDetail.price || 0}`;
    },
    buyButton() {
      if (this.displayBuyBtn) {
        return {
          text: `${this.isPlusMember ? 'VIP：' : ''}￥ ${this.discount}<span style="font-size:12px;"> <del>${this.hasDiscount ? this.goodsDetail.price : ''}</del></span>`,
        };
      }
    },
    shareInfo() {
      return {
        album: this.album,
        sharePath: `/goods/detail/${this.albumId}`,
        contextId: this.selfInviteCode,
      };
    },
  },
  filters: {
    timeFilter(length) {
      return durationFormat(length);
    },
  },
};
</script>

<style scoped>
.album * {
  user-select: text !important;
}
.slide-fade-enter-active {
  transition: all 0.1s ease;
}

.slide-fade-leave-active {
  transition: all 0.1s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}
.album {
  width: 100%;
  padding-bottom: 0;
  box-sizing: border-box;
}

.album-bottom {
  padding-bottom: 53px;
}

.purchase {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
}

.purchase .shadow {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #000;
  opacity: 0.7;
}

.purchase .app-content,
.purchase .buy-content {
  width: 100%;
  border-radius: 8px 8px 0 0;
  background-color: #fff;
  position: absolute;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
}

.app-content {
  padding: 39px 33px 24px 33px;
  height: 195px;
}

.purchase .app-content h6 {
  color: #6b6b6b;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  margin-bottom: 34px;
  padding: 0 4px;
}

.purchase .app-content .app-btn {
  display: block;
  width: 130px;
  height: 42px;
  line-height: 42px;
  border-radius: 8px;
  margin: 0 auto;
  font-size: 16px;
  color: #fff;
  background-color: #3f8dfd;
  text-align: center;
}

.purchase .buy-content {
  overflow: hidden;
}

.purchase .buy-content h5 {
  width: 100%;
  height: 56px;
  background: rgba(248, 248, 248, 1);
  font-size: 17px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}

.purchase .buy-content ul {
  padding: 0 16px;
}

.purchase .buy-content ul li {
  height: 54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.purchase .buy-content ul li + li {
  border-top: 1px solid #f4f4f4;
}

.purchase .buy-content h4 {
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(79, 79, 79, 1);
  line-height: 22px;
}

.purchase .buy-content h3 {
  height: 22px;
  font-size: 16px;
  color: rgba(149, 149, 149, 1);
  line-height: 22px;
}

.purchase .buy-content h3 span {
  color: #4897fd;
}

.purchase .buy-content h3 .arrow-icon {
  width: 5px;
  height: 9px;
  margin-left: 9px;
}

.purchase .buy-content button {
  display: block;
  width: 309px;
  height: 42px;
  border-radius: 8px;
  margin: 14px auto 24px;
  font-size: 18px;
  color: #ffffff;
  line-height: 42px;
}

.album .banner-box .banner {
  display: block;
  height: 155px;
  width: 100vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.banner-box {
  padding-bottom: 20px;
}

.banner-box .content h2 {
  height: 25px;
  line-height: 25px;
  font-size: 18px;
  font-weight: 700;
  color: #444e53;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 20px 0 8px;
  text-align: center;
  padding: 0 29px;
}

.banner-box .content h3 {
  padding: 0 29px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #849198;
  margin-bottom: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.banner-box .content h4 {
  display: inline-block;
  height: 24px;
  font-size: 17px;
  font-weight: 500;
  color: rgba(58, 164, 253, 1);
  line-height: 24px;
  vertical-align: middle;
  margin-right: 12px;
}

.banner-box .content h5 {
  display: inline-block;
  background-color: #ffdf7d;
  height: 20px;
  padding: 0 6px 0 19px;
  font-size: 10px;
  font-weight: 500;
  color: rgba(195, 131, 0, 1);
  line-height: 22px;
  background-image: url('/images/album_vip_ico.png');
  background-size: 11px 10px;
  background-repeat: no-repeat;
  background-position: 5px center;
  box-sizing: border-box;
  border-radius: 3px;
  vertical-align: middle;
}

.banner-box .content .privilege {
  display: block;
  width: 67px;
  margin-left: 1px;
}

.banner-box .content .discount {
  background: #ff6633;
  color: #fff;
  font-size: 14px;
  padding: 5px;
  border-radius: 2px;
}

.plus-goods {
  width: 349px;
  height: 40px;
  background: linear-gradient(180deg, rgba(255, 230, 145, 1) 0%, rgba(255, 218, 113, 1) 100%);
  border-radius: 8px;
  color: #c38300;
  font-size: 14px;
  font-weight: 500;
  margin: 0 auto 16px;
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.plus-goods .plus-goods_img {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.plus-goods .plus-goods_arrow {
  width: 14px;
  height: 14px;
}
.pay-plus {
  width: 349px;
  height: 40px;
  background-image: url('/images/pay_plus_bg.png');
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0 auto 16px;
  padding: 0 11px 0 12px;
  box-sizing: border-box;
}

.pay-plus .icon {
  vertical-align: middle;
  width: 14px;
  height: 14px;
}

.pay-plus .text {
  display: inline-block;
  width: 206px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(195, 131, 0, 1);
  line-height: 40px;
  margin: 0 38px 0 12px;
  vertical-align: middle;
}

.pay-plus button {
  display: inline-block;
  vertical-align: middle;
  width: 56px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  padding: 0;
  background-color: transparent;
}

.banner-box .content ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.banner-box .content li {
  padding: 0 6px;
  width: 70px;
  height: 28px;
  line-height: 28px;
  background: rgb(239, 239, 239);
  border-radius: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #5a666d;
  font-size: 12px;
  margin-right: 9px;
  text-align: center;
}
.banner-box .content li:nth-last-child(1) {
  margin-right: 0;
}

.album .title {
  width: 100vw;
  padding: 0 42px;
  border-bottom: 1px solid #f0f0f0;
  box-sizing: border-box;
}

.album .title p {
  font-size: 15px;
  height: 20px;
  color: #40aeff;
}

.album .depict {
  margin-bottom: 4px;
}

.album .depict-content {
  width: 346px;
  font-size: 13px;
  line-height: 18px;
  color: #666666;
  text-indent: 2rem;
  margin: 20px auto 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  /* display: -webkit-box; */
  /* -webkit-line-clamp: 3; */
  /* -webkit-box-orient: vertical; */
  /* height: 3rem; */
  position: relative;
}

.album .depict-content.overflow {
  height: 3rem;
  margin: 20px auto 2px;
}

.depict-content.overflow::before {
  content: '';
  width: 346px;
  height: 100%;
  text-indent: 2rem;
  position: absolute;
  top: 2.5px;
  display: block;
  background-image: linear-gradient(to top, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.999) 10%, rgba(255, 255, 255, 0) 100%);
}

.depict-content.overflow.active {
  overflow: visible;
  height: auto;
}

.depict-content.overflow.active::before {
  display: none;
}

.depict .show-all {
  width: 100%;
  text-align: center;
}

.depict .show-all > div {
  display: inline-block;
}

.depict .show-all .text {
  height: 18px;
  font-size: 13px;
  line-height: 18px;
  font-weight: 700;
  color: #42a6fe;
}

.arrow {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-top: 1px solid #42a6fe;
  border-right: 1px solid #42a6fe;
  transform: rotate(135deg) translateY(50%);
  margin-right: 4px;
  vertical-align: middle;
  /* animation-duration: 1s; */
}

.arrow.active {
  transform: rotate(316deg) translateY(50%);
  margin-right: 8px;
}
.detail {
  margin-bottom: 15px;
}
.detail li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  position: relative;
}

.detail li h3 {
  display: inline-block;
  width: 100%;
  font-size: 14px;
  text-align: center;
  color: #163134;
  margin-left: 18px;
  margin-right: 16px;
}

.detail li > div {
  border-bottom: 1px solid #e1e6eb;
  padding-bottom: 5px;
  width: 330px;
  margin-right: 3px;
  flex-shrink: 0;
}

.detail li .media-title {
  /* width: 100%; */
  width: 74%;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}

.detail li h4,
.detail li h5 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail li h4 {
  display: inline-block;
  max-width: 200px;
  height: 22px;
  font-size: 16px;
  line-height: 22px;
  color: #163134;
  margin-right: 14px;
}

.detail li .media-title span {
  background-color: #dceeff;
  width: 35px;
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  color: #50adff;
  /* padding: 0 6px; */
  text-align: center;
}

.detail li h5 {
  height: 20px;
  width: 275px;
  font-size: 14px;
  line-height: 20px;
  color: #8a8a8a;
  font-weight: 400;
}

.detail li button {
  display: block;
  background-size: contain;
  background-position: center;
  background-color: transparent;
  background-repeat: no-repeat;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 21px;
  width: 14px;
  height: 16.5px;
  background-image: url('/images/lock.png');
}

.detail li button.unlock {
  width: 16px;
  height: 16px;
  background-image: url('/images/player.png');
}

.detail li.isMore {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.detail li.isMore img {
  display: block;
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

.detail li.isMore .to-app {
  height: 17px;
  text-align: center;
  font-size: 12px;
  line-height: 17px;
  color: #e8e8e8;
  padding: 12px 0;
}

.buttom {
  position: fixed;
  bottom: 0;
  width: 375px;
  height: 50px;
}

.buttom img {
  width: 375px;
}

.pay_plus {
  background: #ff6633;
  color: #fff;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  padding: 5px 13px;
  margin-bottom: 10px;
}

.pay_plus button {
  background: #ca6668;
  padding: 3px;
  font-size: 12px;
  color: #fff;
}
.tab-bar {
  margin-top: 8px;
  height: 42px;
  display: flex;
}
.tab-bar > p {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tab-bar .tab-item {
  font-size: 16px;
  color: rgba(132, 145, 152, 1);
}
.tab-bar .tab-item.current {
  color: rgba(116, 179, 250, 1);
  font-weight: 600;
  position: relative;
}
.tab-bar .tab-item.current::after {
  content: '';
  width: 16px;
  height: 4px;
  background: rgba(116, 179, 250, 1);
  border-radius: 2px;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}
.tab-wrapper {
  width: 100%;
}
.tab-wrapper .detail > ul {
  margin-top: 32px;
}
.wrapper-content.description {
  padding: 0 24px;
}
.tab-wrapper .content-item {
  padding: 32px 0;
  color: #5c6a71;
  font-size: 14px;
  line-height: 24px;
  border-bottom: 1px solid #ededf3;
}
.tab-wrapper .content-item:nth-last-of-type(1) {
  border: none;
}
.tab-wrapper .content-item h5 {
  color: #444e53;
  padding-left: 20px;
  font-weight: 600;
  position: relative;
}
.tab-wrapper .content-item h5::before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.tab-wrapper .content-item > .depict-title::before {
  background: rgba(255, 199, 210, 1);
}
.tab-wrapper .content-item > .remark-title::before {
  background: rgba(199, 222, 255, 1);
}
.album-detaim-img {
  max-width: 100%;
  display: block;
  min-height: 155px;
  border-radius: 3px;
  margin-right: 19px;
  flex-shrink: 0;
  margin: 32px auto 20px;
}
.app-btn-g {
  display: flex;
}
</style>
